import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { CoreService } from '../../services/core.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-demo-signup',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatCardModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './demo-signup.component.html',
  styleUrls: ['./demo-signup.component.scss']
})
export class DemoSignupComponent implements OnInit {
  loading = false;
  message = '';
  success = false;

  // Form data
  company_name = '';
  company_address = '';
  company_city = '';
  user_email = '';
  user_first_name = '';
  user_last_name = '';
  user_phone = '';
  site_url = '';
  platform = 'Facebook';
  social_media_id = '';
  
  // RSS feeds (up to 3)
  rss_feeds = [
    { feed: '', url: '' },
    { feed: '', url: '' },
    { feed: '', url: '' }
  ];

  // Validate that the first RSS feed is provided
  isRssFeedValid(): boolean {
    const firstFeed = this.rss_feeds[0];
    return firstFeed.feed.trim().length > 0 && firstFeed.url.trim().length > 0;
  }

  constructor(
    private coreService: CoreService,
    private router: Router
  ) {}

  ngOnInit(): void {}

  onSubmit(form: NgForm): void {
    // Check if at least one RSS feed is provided
    if (!this.isRssFeedValid()) {
      this.message = 'Please provide at least one complete RSS feed (both name and URL).';
      this.success = false;
      return;
    }

    if (form.invalid) return;

    this.loading = true;
    this.message = '';
    this.success = false;

    // Prepare data matching backend validation
    const formData = {
      company_name: this.company_name,
      company_address: this.company_address || null,
      company_city: this.company_city || null,
      user_email: this.user_email,
      user_first_name: this.user_first_name,
      user_last_name: this.user_last_name,
      user_phone: this.user_phone || null,
      site_url: this.site_url,
      platform: this.platform,
      social_media_id: this.social_media_id,
      rss_feeds: this.rss_feeds.filter(feed => feed.feed.trim() && feed.url.trim())
    };

    this.coreService.postData('demo/store', formData).subscribe({
      next: (response) => {
        if (response.success) {
          this.success = true;
          this.message = 'Account created successfully! Check your email for login details.';
          
          // Optionally redirect to login after success
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 3000);
        } else {
          this.success = false;
          this.message = response.message || 'Failed to create account';
        }
      },
      error: (err) => {
        console.error('Demo account creation error:', err);
        this.success = false;
        this.loading = false;
        this.message = err.error?.message || 'Failed to create account. Please try again.';
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  // Helper to track RSS feed inputs
  trackByIndex(index: number): number {
    return index;
  }
}